import React, { useState, useEffect } from 'react';

import '../Assets/css/custom.css';
import '../Assets/css/w3-css.css';
import {Link} from 'react-router-dom';
import {Redirect} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Header from '../Common/Header';
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";  

import CommonAPI from '../Common/CommonAPI';
import CommonAPI2 from '../Common/FD_BILL_APIs';
import moment from 'moment';
import FadeLoader from "react-spinners/HashLoader"; 


function FDLoanPayments (props) {    
     
     const [SuccessLoading,setSuccessLoading] = useState(false);
     const [PaymentList,setPaymentList] = useState([]);

     useEffect( () => {
        GetFDLoanAPI();        
      },[]);


     const ResponseLoadingModal = () => {
        return(
            <Modal
            size="lg"
            centered 
            className="loading1" show={SuccessLoading}>          
                  <FadeLoader
                  height={25}
                  width={5}
                  radius={2}
                  margin={2}
                  color={"#197b55"}
                  size={"80px"} this also works
                  loading={SuccessLoading}
                />       
           </Modal>
         )
      }

    const GetFDLoanAPI = () =>{
        setSuccessLoading(true);
        CommonAPI2.GetFDLoansPayments((result) =>{   
            if(result){                    
                setPaymentList(result);
                setSuccessLoading(false);
            }                      
        });
      }
      if(SuccessLoading){
        return ( <div>{ResponseLoadingModal()}</div> );
      }
        return (
            <Modal
              show={props.isOpen}
              size="xl"
              aria-labelledby="contained-modal-title-vcenter"
              centered 
              backdrop="static"
              onHide={props.toggle}
            >
              <Modal.Header closeButton>
                <Modal.Title className='hselect' id="contained-modal-title-vcenter">
                  <p className='modal-head-f'>FIXED DDEPOSIT LOAN </p><br/>PAYMENTS
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                
              <Table   className='block-top' hover responsive>
                    <thead >
                        <tr>
                        <th className='td-width3'>Date</th>
                        <th className='td-width3'>Capital Given</th>
                        <th className='td-width3'>Interest Provided</th>                           
                        <th className='td-width3'>VAT Provided</th>                           
                        <th className='td-width3'>Capital Paid</th>                           
                        <th className='td-width3'>Interet Paid</th>                           
                        <th className='td-width3'>VAT Paid</th>                           
                        </tr>
                    </thead>
                    <tbody>
                    {PaymentList.length?PaymentList.map(( listValue, index ) => {
                return( 
                    <tr>
                        <td className='td-width3'>
                            <p className='tb-text m-top'>{moment(listValue.paymentDate).format("DD/MM/YYYY")}</p>
                        </td>
                        <td className='td-width3'>
                            <p className='tb-text m-top'>{listValue.capitalGigen.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                        </td>
                        <td className='td-width3'>
                            <p className='tb-text m-top'>{listValue.interestAmountGiven.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                        </td>
                        <td className='td-width3'>
                            <p className='tb-text m-top'>{listValue.vatGiven.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                        </td>
                        <td className='td-width3'>
                            <p className='tb-text m-top'>{listValue.capitalPaid.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                        </td>
                        <td className='td-width3'>
                            <p className='tb-text m-top'>{(listValue.interestPaid).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                        </td>
                        <td className='td-width3'>
                            <p className='tb-text m-top'>{listValue.vatPaid.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                        </td>
                    </tr>
                )
                }):
                <Row className='tablebody'>
                    <p className='h-text block-top'>No Records</p>
                </Row>
                }
                    </tbody>
                </Table>                              
              </Modal.Body>              
            </Modal>
          );
    }
export default FDLoanPayments;